module.exports = __webpack_public_path__ + "img/purchase_expired.e5389408.png";